/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Subject_Catholic_Religion23Inputs */

const en__field_enum_subject_catholic_religion23 = /** @type {(inputs: _Field_Enum_Subject_Catholic_Religion23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catholic Religion`)
};

const de__field_enum_subject_catholic_religion23 = /** @type {(inputs: _Field_Enum_Subject_Catholic_Religion23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katholische Religion`)
};

/**
* | output |
* | --- |
* | "Catholic Religion" |
*
* @param {_Field_Enum_Subject_Catholic_Religion23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_subject_catholic_religion23 = /** @type {((inputs?: _Field_Enum_Subject_Catholic_Religion23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Subject_Catholic_Religion23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_subject_catholic_religion23(inputs)
	return de__field_enum_subject_catholic_religion23(inputs)
});
export { _field_enum_subject_catholic_religion23 as "_field_enum_SUBJECT_CATHOLIC_RELIGION" }